import type { Card } from '../../shared/types.ts';
import { CARD } from '../../shared/cards.ts';
import { newId } from '../../shared/ids.ts';
import type { Editor } from '../editor.ts';
import type { Tool, WorldPointerEvent } from './types.ts';

/**
 * Click to place a card and open its editor (spec §13.3). Creation and that
 * first editing session form one undo step; a card left completely empty is
 * discarded.
 */
export class CardTool implements Tool {
  cursor = 'crosshair';
  private readonly ed: Editor;
  private createdId: string | null = null;

  constructor(editor: Editor) {
    this.ed = editor;
  }

  onPointerDown(e: WorldPointerEvent): void {
    const ed = this.ed;
    const obj: Card = {
      id: newId(), type: 'card',
      x: e.x - CARD.width / 2, y: e.y - 24, w: CARD.width, h: 0, rotation: 0,
      z: ed.zKeysOnTop(1)[0]!, createdBy: ed.userId,
      title: '', color: ed.cardColor, items: {}, assignees: [],
    };
    obj.h = ed.layouts.cardFace(obj).height;
    ed.beginGesture();
    ed.apply([{ t: 'create', obj }]);
    this.createdId = obj.id;
  }

  onPointerMove(): void {}

  onPointerUp(): void {
    const id = this.createdId;
    if (!id) return;
    this.createdId = null;
    const ed = this.ed;
    ed.setTool('select');
    ed.setSelection([id]);
    ed.openCard(id, { gesture: true, isNew: true });
  }

  onCancel(): void {
    if (!this.createdId) return;
    this.createdId = null;
    this.ed.cancelGesture();
  }
}
